export const ADD_NEW_DOCTOR_PROCESSING = "ADD_NEW_DOCTOR_PROCESSING"
export const ADD_NEW_DOCTOR_SUCCESS = "ADD_NEW_DOCTOR_SUCCESS"
export const ADD_NEW_DOCTOR_FAIL = "ADD_NEW_DOCTOR_FAIL"
export const ADD_NEW_DOCTOR_STATE_RESET = "ADD_NEW_DOCTOR_STATE_RESET"

export const ADD_NEW_RECEPTIONIST_PROCESSING = "ADD_NEW_RECEPTIONIST_PROCESSING"
export const ADD_NEW_RECEPTIONIST_SUCCESS = "ADD_NEW_RECEPTIONIST_SUCCESS"
export const ADD_NEW_RECEPTIONIST_FAIL = "ADD_NEW_RECEPTIONIST_FAIL"
export const ADD_NEW_RECEPTIONIST_STATE_RESET = "ADD_NEW_RECEPTIONIST_STATE_RESET"

export const ADD_NEW_PATIENT_PROCESSING = "ADD_NEW_PATIENT_PROCESSING"
export const ADD_NEW_PATIENT_SUCCESS = "ADD_NEW_PATIENT_SUCCESS"
export const ADD_NEW_PATIENT_FAIL = "ADD_NEW_PATIENT_FAIL"
export const ADD_NEW_PATIENT_STATE_RESET = "ADD_NEW_PATIENT_STATE_RESET"

export const GET_ALL_DOCTOR_PROCESSING = "GET_ALL_DOCTOR_PROCESSING"
export const GET_ALL_DOCTOR_SUCCESS = "GET_ALL_DOCTOR_SUCCESS"
export const GET_ALL_DOCTOR_FAIL = "GET_ALL_DOCTOR_FAIL"
export const GET_ALL_DOCTOR_STATE_RESET = "GET_ALL_DOCTOR_STATE_RESET"

export const UPDATE_DOCTOR_PROCESSING = "UPDATE_DOCTOR_PROCESSING"
export const UPDATE_DOCTOR_SUCCESS = "UPDATE_DOCTOR_SUCCESS"
export const UPDATE_DOCTOR_FAIL = "UPDATE_DOCTOR_FAIL"
export const UPDATE_DOCTOR_STATE_RESET = "UPDATE_DOCTOR_STATE_RESET"

export const DELETE_DOCTOR_PROCESSING = "DELETE_DOCTOR_PROCESSING"
export const DELETE_DOCTOR_SUCCESS = "DELETE_DOCTOR_SUCCESS"
export const DELETE_DOCTOR_FAIL = "DELETE_DOCTOR_FAIL"
export const DELETE_DOCTOR_STATE_RESET = "DELETE_DOCTOR_STATE_RESET"

export const GET_SINGLE_DOCTOR_PROCESSING = "GET_SINGLE_DOCTOR_PROCESSING"
export const GET_SINGLE_DOCTOR_SUCCESS = "GET_SINGLE_DOCTOR_SUCCESS"
export const GET_SINGLE_DOCTOR_FAIL = "GET_SINGLE_DOCTOR_FAIL"
export const GET_SINGLE_DOCTOR_STATE_RESET = "GET_SINGLE_DOCTOR_STATE_RESET"


export const GET_ALL_RECEPTIONIST_PROCESSING = "GET_ALL_RECEPTIONIST_PROCESSING"
export const GET_ALL_RECEPTIONIST_SUCCESS = "GET_ALL_RECEPTIONIST_SUCCESS"
export const GET_ALL_RECEPTIONIST_FAIL = "GET_ALL_RECEPTIONIST_FAIL"

export const UPDATE_RECEPTIONIST_PROCESSING = "UPDATE_RECEPTIONIST_PROCESSING"
export const UPDATE_RECEPTIONIST_SUCCESS = "UPDATE_RECEPTIONIST_SUCCESS"
export const UPDATE_RECEPTIONIST_FAIL = "UPDATE_RECEPTIONIST_FAIL"
export const UPDATE_RECEPTIONIST_STATE_RESET = "UPDATE_RECEPTIONIST_STATE_RESET"

export const DELETE_RECEPTIONIST_PROCESSING = "DELETE_RECEPTIONIST_PROCESSING"
export const DELETE_RECEPTIONIST_SUCCESS = "DELETE_RECEPTIONIST_SUCCESS"
export const DELETE_RECEPTIONIST_FAIL = "DELETE_RECEPTIONIST_FAIL"
export const DELETE_RECEPTIONIST_STATE_RESET = "DELETE_RECEPTIONIST_STATE_RESET"

export const GET_SINGLE_RECEPTIONIST_PROCESSING = "GET_SINGLE_RECEPTIONIST_PROCESSING"
export const GET_SINGLE_RECEPTIONIST_SUCCESS = "GET_SINGLE_RECEPTIONIST_SUCCESS"
export const GET_SINGLE_RECEPTIONIST_FAIL = "GET_SINGLE_RECEPTIONIST_FAIL"
export const GET_SINGLE_RECEPTIONIST_STATE_RESET = "GET_SINGLE_RECEPTIONIST_STATE_RESET"

export const GET_ALL_PATIENT_PROCESSING = "GET_ALL_PATIENT_PROCESSING"
export const GET_ALL_PATIENT_SUCCESS = "GET_ALL_PATIENT_SUCCESS"
export const GET_ALL_PATIENT_FAIL = "GET_ALL_PATIENT_FAIL"

export const DELETE_PATIENT_PROCESSING = "DELETE_PATIENT_PROCESSING"
export const DELETE_PATIENT_SUCCESS = "DELETE_PATIENT_SUCCESS"
export const DELETE_PATIENT_FAIL = "DELETE_PATIENT_FAIL"
export const DELETE_PATIENT_STATE_RESET = "DELETE_PATIENT_STATE_RESET"

export const GET_SINGLE_PATIENT_PROCESSING = "GET_SINGLE_PATIENT_PROCESSING"
export const GET_SINGLE_PATIENT_SUCCESS = "GET_SINGLE_PATIENT_SUCCESS"
export const GET_SINGLE_PATIENT_FAIL = "GET_SINGLE_PATIENT_FAIL"
export const GET_SINGLE_PATIENT_STATE_RESET = "GET_SINGLE_PATIENT_STATE_RESET"

export const UPDATE_PATIENT_PROCESSING = "UPDATE_PATIENT_PROCESSING"
export const UPDATE_PATIENT_SUCCESS = "UPDATE_PATIENT_SUCCESS"
export const UPDATE_PATIENT_FAIL = "UPDATE_PATIENT_FAIL"
export const UPDATE_PATIENT_STATE_RESET = "UPDATE_PATIENT_STATE_RESET"

export const ADD_NEW_CONSULTANT_PROCESSING = "ADD_NEW_CONSULTANT_PROCESSING"
export const ADD_NEW_CONSULTANT_SUCCESS = "ADD_NEW_CONSULTANT_SUCCESS"
export const ADD_NEW_CONSULTANT_FAIL = "ADD_NEW_CONSULTANT_FAIL"
export const ADD_NEW_CONSULTANT_STATE_RESET = "ADD_NEW_CONSULTANT_STATE_RESET"

export const GET_ALL_CONSULTANT_PROCESSING = "GET_ALL_CONSULTANT_PROCESSING"
export const GET_ALL_CONSULTANT_SUCCESS = "GET_ALL_CONSULTANT_SUCCESS"
export const GET_ALL_CONSULTANT_FAIL = "GET_ALL_CONSULTANT_FAIL"

export const DELETE_CONSULTANT_PROCESSING = "DELETE_CONSULTANT_PROCESSING"
export const DELETE_CONSULTANT_SUCCESS = "DELETE_CONSULTANT_SUCCESS"
export const DELETE_CONSULTANT_FAIL = "DELETE_CONSULTANT_FAIL"
export const DELETE_CONSULTANT_STATE_RESET = "DELETE_CONSULTANT_STATE_RESET"

export const GET_SINGLE_CONSULTANT_PROCESSING = "GET_SINGLE_CONSULTANT_PROCESSING"
export const GET_SINGLE_CONSULTANT_SUCCESS = "GET_SINGLE_CONSULTANT_SUCCESS"
export const GET_SINGLE_CONSULTANT_FAIL = "GET_SINGLE_CONSULTANT_FAIL"
export const GET_SINGLE_CONSULTANT_STATE_RESET = "GET_SINGLE_CONSULTANT_STATE_RESET"

export const UPDATE_CONSULTANT_PROCESSING = "UPDATE_CONSULTANT_PROCESSING"
export const UPDATE_CONSULTANT_SUCCESS = "UPDATE_CONSULTANT_SUCCESS"
export const UPDATE_CONSULTANT_FAIL = "UPDATE_CONSULTANT_FAIL"
export const UPDATE_CONSULTANT_STATE_RESET = "UPDATE_CONSULTANT_STATE_RESET"

export const ADD_APPOINTMENT_PROCESSING = "ADD_APPOINTMENT_PROCESSING"
export const ADD_APPOINTMENT_SUCCESS = "ADD_APPOINTMENT_SUCCESS"
export const ADD_APPOINTMENT_FAIL = "ADD_APPOINTMENT_FAIL"
export const ADD_APPOINTMENT_STATE_RESET = "ADD_APPOINTMENT_STATE_RESET"

export const GET_ALL_APPOINTMENT_PROCESSING = "GET_ALL_APPOINTMENT_PROCESSING"
export const GET_ALL_APPOINTMENT_SUCCESS = "GET_ALL_APPOINTMENT_SUCCESS"
export const GET_ALL_APPOINTMENT_FAIL = "GET_ALL_APPOINTMENT_FAIL"

export const ADD_ENQUIRY_PROCESSING = "ADD_ENQUIRY_PROCESSING"
export const ADD_ENQUIRY_SUCCESS = "ADD_ENQUIRY_SUCCESS"
export const ADD_ENQUIRY_FAIL = "ADD_ENQUIRY_FAIL"
export const ADD_ENQUIRY_STATE_RESET = "ADD_ENQUIRY_STATE_RESET"

export const ADD_PRESCRIPTION_PROCESSING = "ADD_PRESCRIPTION_PROCESSING"
export const ADD_PRESCRIPTION_SUCCESS = "ADD_PRESCRIPTION_SUCCESS"
export const ADD_PRESCRIPTION_FAIL = "ADD_PRESCRIPTION_FAIL"
export const ADD_PRESCRIPTION_STATE_RESET = "ADD_PRESCRIPTION_STATE_RESET"

export const DELETE_PRESCRIPTION_PROCESSING = "DELETE_PRESCRIPTION_PROCESSING"
export const DELETE_PRESCRIPTION_SUCCESS = "DELETE_PRESCRIPTION_SUCCESS"
export const DELETE_PRESCRIPTION_FAIL = "DELETE_PRESCRIPTION_FAIL"
export const DELETE_PRESCRIPTION_STATE_RESET = "DELETE_PRESCRIPTION_STATE_RESET"
export const SET_CLINIC_PROFILE = "SET_CLINIC_PROFILE"

export const GET_ALL_PATIENT_PRESCRIPTION_DATA = "GET_ALL_PATIENT_PRESCRIPTION_DATA"
